import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import QRCodeVue from 'vue-qrcode';
import '@/assets/css/global.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import dataV from '@jiaminghi/data-view'
import VueCookies from "vue-cookies";
import axios from "axios";
import VueAxios from 'vue-axios';
import store from './store/store'
// import 'highlight.js/styles/stackoverflow-light.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'




const app = createApp(App)
// app.provide('request',request)
app.config.globalProperties.$aaa = 100;

app.config.globalProperties.$axios = axios;

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
//这是设置elementplus为中文
app.use(ElementPlus, {
    locale: zhCn,
})

app.use(ElementPlus)
app.use(QRCodeVue)
app.use(VueCookies);
app.use(dataV);
app.use(ElementPlus);
app.use(router);
app.use(store);
// app.use(qs);
app.use(VueAxios,axios);
app.mount('#app')

//以下代码是因为用户管理模块，浏览器窗口变化时出现报错
const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce((...args) => {
            const entries = args[0]; // ResizeObserver entries
            for (const entry of entries) {
                // 确保目标元素存在
                if (entry.target && entry.target.getBoundingClientRect) {
                    callback(...args);
                }
            }
        }, 200);
        super(callback);
    }
};
